import Vue from 'vue'
import PlannrUi from '@plannrcrm/plannr-ui'

Vue.use(PlannrUi)
